import { apiSlice } from 'state/slices/apiSlice';

const REQUEST_LEAVE_URL = '/leaves';

export const requestLeaveApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createRequestLeave: builder.mutation({
      query: (requestLeaveData) => ({
        url: `${REQUEST_LEAVE_URL}/request`,
        method: 'POST',
        body: requestLeaveData,
        transformResponse: (response) => response.json(),
      }),
    }),
    getRequestLeaves: builder.query({
      query: ({ year, month, id = null }) => id ? `${REQUEST_LEAVE_URL}/${year}/${month}/${id}` : `${REQUEST_LEAVE_URL}/${year}/${month}`,
    }),
    updateRequestLeave: builder.mutation({
      query: (data) => {
        return {
          url: `${REQUEST_LEAVE_URL}/update`,
          method: 'PUT',
          body: { ...data },
        };
      },
    }),
    deleteRequestLeave: builder.mutation({
      query: (id) => ({
        url: `${REQUEST_LEAVE_URL}/delete`,
        method: 'DELETE',
        body: { id }
      }),
    }),
  }),
});

export const {
  useCreateRequestLeaveMutation,
  useGetRequestLeavesQuery,
  useUpdateRequestLeaveMutation,
  useDeleteRequestLeaveMutation,
} = requestLeaveApiSlice;

